<template>
  <div
    class="c-sort-switch c:row-center"
    :class="{ active }"
    @click="throttledOnClick"
  >
    <div class="c-sort-switch-label">{{ label }}</div>
    <div class="ordering">
      <img
        v-if="active"
        class="ordering-icon"
        :class="{ 'is-desc': !isAsc }"
        src="@/assets/icons/ordering-active.svg"
        alt=""
      />
      <img
        v-else
        class="ordering-icon"
        src="@/assets/icons/ordering-inactive.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    label: String,
    value: String, // 'createTime' | 'amount'
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAsc: true,
    };
  },
  created() {
    this.throttledOnClick = throttle(this.onClick, 500);
  },
  methods: {
    onClick() {
      if (this.active) {
        if (this.isAsc) {
          this.isAsc = false;
          this.$emit("change", {
            sort: this.value,
            asc: false,
          });
        } else {
          this.$emit("change", {
            sort: undefined,
            asc: undefined,
          });
        }
      } else {
        this.isAsc = true;
        this.$emit("change", {
          sort: this.value,
          asc: true,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.c-sort-switch {
  gap: 6/20rem;

  box-sizing: border-box;
  width: auto;
  height: 23/20rem;
  padding: 3/20rem 8/20rem;
  background: #f7f7f7;
  border-radius: 3/20rem;

  font-weight: 400;
  font-size: 0;

  &.active {
    background: #eeeeee;
    font-weight: 500;
  }

  .c-sort-switch-label {
    height: 18/20rem;
    line-height: 18/20rem;
    font-size: 12/20rem;
    letter-spacing: 0;
  }

  .ordering {
    width: 8/20rem;
    height: 12/20rem;

    .ordering-icon {
      width: 8/20rem;
      height: 12/20rem;

      &.is-desc {
        transform: rotate(180deg);
        transform-origin: center center;
      }
    }
  }
}
</style>
